import React from 'react';

import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {Picture} from '@udemy/react-core-components';
import {tokens} from '@udemy/styles';

import styles from './feature-cards.module.less';

export function FeatureCards() {
    const {gettext, interpolate} = useI18n();

    const termsApplyTemplate = gettext(
        'Unlock expanded access to new and powerful features in Gemini, Flow, and NotebookLM as well as AI-powered assistance from Gemini directly in the Google apps you know and use, like Gmail and Google Docs. Plus, get 2 TB of cloud storage. <a class="termsApplyLink">%(termsApplyText)s</a>',
    );
    const termsApplyHtml = interpolate(
        termsApplyTemplate,
        {termsApplyText: gettext('Terms apply')},
        true,
    );

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles['image-container']}>
                    <Picture
                        sources={[
                            {
                                srcSet: 'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/gemini-3-pro-mobile.webp',
                                media: `(max-width: ${tokens['breakpoint-sm-max']})`,
                                width: 80,
                                height: 80,
                            },
                            {
                                srcSet: 'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/gemini-3-pro-desktop.webp',
                                media: `(min-width: ${tokens['breakpoint-lg-min']})`,
                                width: 290,
                                height: 290,
                            },
                        ]}
                        alt={gettext('Gemini 3 Pro')}
                        src="https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/gemini-3-pro-desktop.webp"
                    />
                </div>
                <div className={styles['content-container']}>
                    <div>
                        <h3 className={styles.heading}>
                            {gettext('Get 3 months no cost access to Google AI Pro')}
                        </h3>
                    </div>
                    <p className={styles.description}>
                        <LocalizedHtml
                            html={termsApplyHtml}
                            interpolate={{
                                termsApplyLink: (
                                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                                    <a
                                        href="https://www.udemy.com/terms/learn-with-google/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={'ud-link-underline'}
                                    />
                                ),
                            }}
                        />
                    </p>
                </div>
            </div>
            <div className={styles.card}>
                <div className={styles['image-container']}>
                    <Picture
                        sources={[
                            {
                                srcSet: 'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/practice-test-mobile.webp',
                                media: `(max-width: ${tokens['breakpoint-sm-max']})`,
                                width: 80,
                                height: 80,
                            },
                            {
                                srcSet: 'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/practice-test-desktop.webp',
                                media: `(min-width: ${tokens['breakpoint-lg-min']})`,
                                width: 290,
                                height: 290,
                            },
                        ]}
                        alt={gettext('Learning designed to help you start doing')}
                        src="https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/grow-with-google/practice-test-desktop.webp"
                    />
                </div>
                <div className={styles['content-container']}>
                    <div>
                        <h3 className={styles.heading}>
                            {gettext('Build AI fluency through real-world practice')}
                        </h3>
                    </div>
                    <p className={styles.description}>
                        {gettext(
                            'Put your skills to work with interactive activities based on real job tasks. Practice in the tools you use every day, build custom AI solutions, and create automated workflows you can use on day one.',
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
}
